import { Box, Skeleton, Stack, Typography } from "@mui/material";

const TranscriptSkeletion = () => {
  const skeletonWidths = [
    "25%", "80%", "25%", "80%","25%", "80%","25%", "80%",
  ];

  return (
    <Box sx={{ height: "100%",overflow:"hidden" }}>
      <Stack sx={{ height: "100%", width: "100%" }}>
        <Box
          sx={{
            backgroundColor: "#FFFFFF",
            height: "100%",
            borderRadius: "4px",
          }}
        >
          <Stack
            direction={"row"}
            px={2}
            py={1}
            justifyContent={"space-between"}
          >
            <Typography sx={{ fontSize: "16px", fontWeight: "600" }}>
              Transcript
            </Typography>
            <Skeleton
              variant="rounded"
              height={30}
              width={80}
              sx={{ backgroundColor: "#E6E6E6" }}
            />
          </Stack>
          <Stack
            direction="row"
            justifyContent={"space-between"}
            mb={2}
            p={1}
          >
            <Skeleton
              variant="rounded"
              height={30}
              width={"20%"}
              sx={{ backgroundColor: "#E6E6E6" }}
            />
            <Skeleton
              variant="rounded"
              height={30}
              width={"50%"}
              sx={{ backgroundColor: "#E6E6E6" }}
            />
            <Skeleton
              variant="rounded"
              height={30}
              width={"20%"}
              sx={{ backgroundColor: "#E6E6E6" }}
            />
          </Stack>
          <Stack
            direction="column"
            justifyContent="center"
            sx={{
                boxSizing: "border-box", 
            }}
          >
           {skeletonWidths?.map((pref, i) => {
              const height = i % 2 ? 100 : 30;
              return (
                <Skeleton
                  key={i}
                  variant="rounded"
                  height={height}
                  width={pref}
                  sx={{
                    backgroundColor: "#E6E6E6",
                    my: 1,
                    ml: i % 2 ? 6 : 3,
                  }}
                />
              );
            })}
          </Stack>
        </Box>
      </Stack>
    </Box>
  );
};

export default TranscriptSkeletion;
